// Utils
import { useWeekDayCheckBoxStyles } from "src/components/Selector/WeekDayCheckbox.style";
import { daysOfTheWeek } from "src/utils/formatters";

// Components
import { Checkbox } from "./Checkbox";

export interface WeekDayCheckBoxProps {
    handleChange: (values: number[]) => void;
    value: number[];
}

export function WeekDayCheckBox({ handleChange, value }: WeekDayCheckBoxProps): JSX.Element {
    const checkboxes = daysOfTheWeek({ shortLabel: true });
    const classes = useWeekDayCheckBoxStyles();

    const handleChangeValue = (event) => {
        const item = event.target.name;
        const isChecked = event.target.checked;
        const key = checkboxes.find((checkbox) => checkbox.name === item).key;
        if (isChecked) {
            handleChange([...value, key]);
        } else {
            handleChange(value.filter((item) => item !== key));
        }
    };

    return (
        <div className={classes.container}>
            {checkboxes.map((item) => (
                <Checkbox
                    key={item.name}
                    name={item.name}
                    value={item.name}
                    label={item.label}
                    checked={value.indexOf(item.key) !== -1}
                    onChange={handleChangeValue}
                    className={classes.item}
                />
            ))}
        </div>
    );
}
